import { Button } from "@mui/material";
import { styled } from "@mui/material/styles";
import { Tab } from "@navigations/Tabs/Tab";

export const ActionButton = styled(Button)(({ theme }) => ({
  "&:disabled": {
    color: "rgba(255, 255, 255, 0.7)",
    backgroundColor: theme.palette.primary.main,
  },
}));

export const MenuButton = styled(Button)(({ theme }) => ({
  "&:disabled": {
    color: theme.palette.primary.main,
    borderColor: theme.palette.primary.main,
  },
}));

export const ActionTab = styled(Tab)(() => ({
  margin: "0px !important",
  "& button": {
    marginRight: "10px",
  },
}));
